
import React from "react";
import WarningAlert from '../../utils/WarningAlert';
import { toast } from 'react-toastify';
import {useDeleteEnrollmentReviewMutation} from "../../Services/api";
export default function DeleteEnrollReview(props) {
    const notify = () => '';

    const [deleteEnrollmentReview] = useDeleteEnrollmentReviewMutation();
    const handleDelete = async (index,e) => {
        const values={id:index}
        var confirm = await WarningAlert();
        if(confirm===true){
            deleteEnrollmentReview({ data: values }).unwrap()
            .then((payload) => {
                if (payload.status) {
                    toast.success(payload.message)
                }else{
                    toast.error(payload.message)
                }
            }).catch((error) => {
                toast.error(error.data.message)
            });
            notify();
        }   
    }
    return (<>
          <button className="dropdown-item"
                onClick={e => handleDelete(props.id,e)}>
                    <div className="icon text-danger">
                    <i className="bi bi-trash"></i>
                        Delete
                    </div>
                </button>
       
    </>)
}